(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["site-header"]) return;
  try {
    
$(function() {

	function openSubMenu(elem){
      subOpenTitle = elem.find('a.lev-1').text();
      $('.main-menu-close .menu-back').text(subOpenTitle);
      $('body').addClass('header-sub__is-open');
      elem.addClass('open'); 
    }
    function closeSubMenu(){
      $('.main-menu-container li').removeClass('open');
      $('body').removeClass('header-sub__is-open');
      $('.main-menu-close .menu-back').text('');
      $('.main-submenu').scrollTop(0);
    }
    function closeMobMenu(){
      $('body').removeClass('header-nav__is-open');
      closeSubMenu();
    }
    function openMobMenu(){
      $('body').addClass('header-nav__is-open');
    }
    function toggleMobMenu(){
      if($('body').hasClass('header-nav__is-open')){
        closeMobMenu();
      } else {
        openMobMenu();
      }
    }
	$(".main-menu-close .menu-back").on("click", function(event){
      	closeSubMenu();
    }); 
    $(".main-menu li.has-child").on("click", function(event){
      	openSubMenu($(this));
    });
    $("#toggle-main").on("click", function(event){
    	toggleMobMenu();
    });
    $("#underlay-main, .menu-close").on("click", function(event){
    	closeMobMenu();
    });
});

  } catch(e) { console.error(e); }
})();
})();
